import React from "react"
import PropTypes from "prop-types"
import { RxCross2 } from "react-icons/rx"
import { FaRegCheckCircle } from "react-icons/fa"

const LittleCards = ({ items, negative }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      {items.map((misconception, index) => (
        <div
          key={index}
          className={`flex flex-col items-center p-4 ${
            negative ? "bg-red-100" : "bg-green-100"
          } rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300`}
        >
          {negative ? (
            <RxCross2 className="text-red-600 mb-2" size={24} />
          ) : (
            <FaRegCheckCircle className="text-green-600 mb-2" size={24} />
          )}
          <p className="text-center font-semibold">{misconception}</p>
        </div>
      ))}
    </div>
  )
}

LittleCards.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  negative: PropTypes.bool,
}

export default LittleCards
